import React from "react";
import AntdBreadcrumb, { BreadcrumbProps } from "antd/lib/breadcrumb";
import BreadcrumbItem from "antd/lib/breadcrumb/BreadcrumbItem";
import BreadcrumbSeparator from "antd/lib/breadcrumb/BreadcrumbSeparator";

import { withError} from '@fishx/tracker';


interface FCBreadcrumbProps extends React.FC<BreadcrumbProps> {
  Item: typeof BreadcrumbItem;
  Separator: typeof BreadcrumbSeparator;

}
const Breadcrumb: FCBreadcrumbProps = (props) => <AntdBreadcrumb {...props} />
Breadcrumb.Item = BreadcrumbItem;
Breadcrumb.Separator = BreadcrumbSeparator;
Breadcrumb.displayName = 'Breadcrumb';
export default withError(Breadcrumb);


// WEBPACK FOOTER //
// ./src/components/breadcrumb/index.tsx